import styled, { keyframes } from 'styled-components';
import { Box, themedColor, easeOutQuad } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';

const Container = styled(Box)``;

const BASE_MOCK_DURATION = 1000;

const dotAnimation = keyframes`
    0% { transform: translateX(60vw); }
    90% { transform: translateX(-10px); }
    100% { transform: translateX(0); }
`;

const dotAnimationMobile = keyframes`
    0% { transform: translateX(60vw); }
    90% { transform: translateX(-5px); }
    100% { transform: translateX(0); }
`;

const Dot = styled(Box)`
  background-color: ${themedColor('primary')};
  z-index: 2;
  position: relative;
  border-radius: 50%;
  animation-play-state: paused;
  animation-duration: ${BASE_MOCK_DURATION}ms;

  ${MEDIA_QUERIES.upToDesktop`
        animation-name: ${dotAnimationMobile};
        top: 187px;
        left: 118px;
        width: 12px;
        height: 12px;
    `}

  ${MEDIA_QUERIES.desktop`
        animation-name: ${dotAnimation};
        top: 246px;
        left: 328px;
        width: 25px;
        height: 25px;
    `}
`;

export default function Giveback2020FinalDot({ t, ...props }) {
  const style = {
    animationDelay: `${-easeOutQuad(t) * (BASE_MOCK_DURATION - 1)}ms`,
  };

  return (
    <Container {...props}>
      <Dot style={style} />
    </Container>
  );
}
